/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query AccessTokenReadUniqueQuery($bindToTable: String!, $bindableId: ID!) {
    AccessTokenReadUnique(bindToTable: $bindToTable, bindableId: $bindableId) {
      token,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
